module.exports = __webpack_public_path__ + "static/media/shape0_0.a2f89f65.obj";